'use client';

import { Box } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import CustomTextField from '../../theme-elements/CustomTextField';
import countryData from './countrydata';

const countryToFlag = (isoCode: any) =>
  typeof String.fromCodePoint !== 'undefined'
    ? isoCode
        .toUpperCase()
        .replace(/./g, (char: any) =>
          String.fromCodePoint(char.charCodeAt(0) + 127397),
        )
    : isoCode;

interface CountrySelectAutocompleteProps {
  value?: any;
  onChange?: (value: any) => void;
  error?: boolean;
  helperText?: string;
}

const CountrySelectAutocomplete = ({ 
  value, 
  onChange, 
  error, 
  helperText 
}: CountrySelectAutocompleteProps) => {
  return (
    <Autocomplete
      id="country-select-demo"
      multiple={false}
      fullWidth
      value={value || null}
      onChange={(_event, newValue) => {
        if (onChange) {
          onChange(newValue);
        }
      }}
      options={countryData}
      autoHighlight
      getOptionLabel={option => option.label}
      renderOption={(props, option) => {
        const { key, ...optionProps } = props;
        return (
          <Box
            key={key}
            component="li"
            sx={{ fontSize: 15, '& > span': { mr: '10px', fontSize: 18 } }}
            {...optionProps}
          >
            <span>{countryToFlag(option.code)}</span>
            {option.label} ({option.code}) +{option.phone}
          </Box>
        );
      }}
      renderInput={params => (
        <CustomTextField
          {...params}
          placeholder="Choose a country"
          aria-label="Choose a country"
          autoComplete="off"
          error={error}
          helperText={helperText}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password', // disable autocomplete and autofill
          }}
        />
      )}
    />
  );
};

export default CountrySelectAutocomplete;
